<template>
    <div ref="languageSelector" class="language-selector">
        <button :disabled="!showLanguageSetting" @click="toggleLanguageDropdown" class="language-btn">
            <svg width="24" height="24" viewBox="0 0 24 24">
                <path :d="mdiWeb" />
            </svg>
        </button>

        <div v-if="showLanguageDropdown" class="language-dropdown">
            <button v-for="lang in languages" :key="lang.code"
                :class="{ 'active-language': lang.code === selectedLanguage }" @click="selectLanguage(lang.code)"
                class="language-option">
                {{ lang.display || $t(lang.name) }}
            </button>
        </div>
    </div>
</template>

<script>
import { mdiWeb } from '@mdi/js';
export default {
    name: 'LanguageSetting',
    props: {
        showLanguageSetting: Boolean,
        selectedLanguage: String,
        languages: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            showRawNameLanguage: false,
            showLanguageDropdown: false,
            mdiWeb: mdiWeb
        }
    },
    methods: {
        toggleLanguageDropdown() {
            this.showLanguageDropdown = !this.showLanguageDropdown;
        },
        selectLanguage(langCode) {
            this.showLanguageDropdown = false;
            this.$emit('language-selected', langCode);
        },
        closeDropdown(event) {
            if (this.$refs.languageSelector && !this.$refs.languageSelector.contains(event.target)) {
                this.showLanguageDropdown = false;
            }
        }
    },
    mounted() {
        window.addEventListener('click', this.closeDropdown);
    },
    beforeUnmount() {
        window.removeEventListener('click', this.closeDropdown);
    }
};
</script>

<style scoped>
.language-selector {
    position: fixed;
    top: 12px;
    right: 48px;
    z-index: 9999;
}

.language-btn {
    font-weight: 700;
    padding: 4px;
    border: none;
    color: var(--text-color);
    cursor: pointer;
    align-items: center;
    appearance: none;
    background: none;
    display: flex;
    -webkit-tap-highlight-color: transparent;
    background-color: var(--surface-color);
    border-radius: 50%;
}

.language-btn svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
}

.language-btn:hover {
    background-color: var(--primary-hover);
    border-radius: 50%;
}

.language-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 2px;
    padding-top: 16px;
    width: 200px;
    max-height: 260px;
    background-color: var(--container-color);
    border: none;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    overflow-y: auto;
    z-index: 1300;
}

.language-option {
    display: block;
    width: 100%;
    padding: 16px 16px;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    border: none;
    background-color: transparent;
    color: var(--text-color);
    text-align: left;
    cursor: pointer;
}

.language-option:hover {
    background-color: var(--highlight-color);
    color: var(--reverse-color);
}

.active-language {
    background-color: var(--primary-hover);
    color: white;
    font-weight: bold;
}
</style>